import React from "react";
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
  buttonLink: {
    border: "none",
    background: "none",
    color: theme.palette.primary.main,
    fontSize: theme.typography.pxToRem(16),
    padding: theme.spacing(1),
    marginLeft: theme.spacing(1),
    cursor: "pointer"
  }
});

const OSSButtonLink = ({ classes, clickhandler, children, ...rest }) => {
  return (
    <button className={classes.buttonLink} onClick={clickhandler} {...rest}>
      {children}
    </button>
  );
};

export default withStyles(styles)(OSSButtonLink);
